const clean = (params = {}) => Object.fromEntries(Object.entries(params).filter(([, value]) => value !== "" && value != null));

const createPrintfulApi = ({ baseUrl, getToken }) => {
  const request = async (path, { method = "GET", body, params } = {}) => {
    const query = new URLSearchParams(clean(params)).toString();
    const token = typeof getToken === "function" ? getToken() : getToken;
    const response = await fetch(`${String(baseUrl || "").replace(/\/$/, "")}${path}${query ? `?${query}` : ""}`, {
      method,
      headers: { Accept: "application/json", "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.error || `HTTP ${response.status}`), { status: response.status, code: data.code });
    return data;
  };
  return {
    getPlatform: () => request("/dropshipping/printful/platform"),
    getConnection: () => request("/dropshipping/printful/connection"),
    connect: (payload = {}) => request("/dropshipping/printful/connect", { method: "POST", body: payload }),
    testConnection: () => request("/dropshipping/printful/test-connection", { method: "POST" }),
    disconnect: () => request("/dropshipping/printful/disconnect", { method: "POST" }),
    getSuppliers: () => request("/dropshipping/printful/suppliers"),
    getSupplierProducts: (supplierId, params) => request(`/dropshipping/printful/suppliers/${supplierId}/products`, { params }),
    getProducts: (params) => request("/dropshipping/printful/products", { params }),
    getProduct: (id) => request(`/dropshipping/printful/products/${id}`),
    importProduct: (payload) => request("/dropshipping/printful/products/import", { method: "POST", body: payload }),
    syncAll: () => request("/dropshipping/printful/sync", { method: "POST" }),
    syncProduct: (id) => request(`/dropshipping/printful/products/${id}/sync`, { method: "POST" }),
    updateSyncLocks: (id, locks) => request(`/dropshipping/printful/products/${id}/sync-locks`, { method: "PATCH", body: { locks } }),
    getImportedProducts: (params) => request("/dropshipping/printful/imported-products", { params }),
    getOrders: (params) => request("/dropshipping/printful/orders", { params }),
    createSupplierOrder: (orderId, sellerId) => request(`/dropshipping/printful/orders/${orderId}/create`, { method: "POST", body: sellerId ? { sellerId } : {} }),
    syncOrder: (id) => request(`/dropshipping/printful/orders/${id}/sync`, { method: "POST" }),
    getErrors: () => request("/dropshipping/printful/errors"),
    getAdminOverview: () => request("/dropshipping/printful/admin/overview"),
    getAdminConnections: () => request("/dropshipping/printful/admin/connections"),
    updateAdminPlatform: (payload) => request("/dropshipping/printful/admin/platform", { method: "PATCH", body: payload }),
    syncAllSellers: () => request("/dropshipping/printful/admin/sync", { method: "POST" }),
  };
};

module.exports = { createPrintfulApi };
